<template>
  <div>
    <div class="text-h6 text-primaryText font-weight-bold mb-4">
      Order Summary
    </div>

    <!-- Product List section -->
    <div>
      <CheckoutProductListSkeleton />
    </div>

    <v-divider class="my-4"></v-divider>

    <!-- Gift card coupon Section skeleton -->
    <div>
      <GiftCardSkeleton />
    </div>

    <v-divider class="my-4"></v-divider>

    <!-- Totals Section -->
    <div>
      <CartTotalSkeleton />
    </div>
  </div>
</template>
<script>
import CartTotalSkeleton from "./CartTotalSkeleton.vue";
import CheckoutProductListSkeleton from "./CheckoutProductListSkeleton.vue";
import GiftCardSkeleton from "./GiftCardSkeleton.vue";

export default {
  name: "CheckoutProductSkeleton",
  props: ["checkoutProductList"],
  components: {
    CheckoutProductListSkeleton,
    CartTotalSkeleton,
    GiftCardSkeleton,
  },
};
</script>
